import { useTranslation } from "react-i18next"


import inputStyle from "../../../../sass/custom/inputs.module.scss"
import buttonStyle from "../../../../sass/custom/buttons.module.scss"
import { validators } from "../../../../validators/validators"
import { useEffect } from "react"
import { selectUpdatingDocsWeightStatus, updateDocsWeight } from "../shipmentItemsSlice"
import { useDispatch, useSelector } from "react-redux"
import { useState } from "react"
import { pushAlert } from "../../../alerts/alertSlice"


const DocsItem = ({ initialWeight, shipmentID }) => {
    const dispatch = useDispatch()
    const { t } = useTranslation()

    const [weight, setWeight] = useState(initialWeight)
    const [weightChanged, setWeightChanged] = useState(false)
    const status = useSelector(selectUpdatingDocsWeightStatus)

    useEffect(() => {
        if(status === "fulfilled") {
            dispatch(pushAlert({
                message: t("shipment.docs.success_updating"),
                type: "success",
                delay: 2500
            }))
            setWeightChanged(false)
        }
    }, [dispatch, status])

    const handleWeightChange = (e) => {
        let value = e.target.value
        if (!value) {
            setWeight("")
        }
        value = value.toString().replace(",", ".");
        if (!value) {
            setWeight(value)
        }
        let err = validators.ValidateNumber(value);
        if (err !== null) {
            return;
        }

        if (+value >= 1000) {
            return
        }

        let pointIndex = value.indexOf(".")
        if (pointIndex >= 0 && value.length - (pointIndex + 1) > 2) {
            value = value.slice(0, pointIndex + 1 + 2)
        }

        if (value === initialWeight) {
            setWeightChanged(false)
            return
        }

        setWeightChanged(true)
        setWeight(value)
    }

    const handleSaveButtonClick = () => {
        let numError = validators.ValidateNumber(weight)
        if(numError) {
            dispatch(pushAlert({
                message: t("shipment.docs.warning"),
                delay: 2500
            }))
        }
        let value = +weight
        dispatch(updateDocsWeight({shipmentID, weight: value}))
    }

    return (
        <div className="flex items-center gap-4 flex-wrap">
            <span>
                {t("shipment.docs.weight")}  {" "} ({t("required")}):
            </span>
            <input
                type="nubmer"
                className={`${inputStyle.input} ${inputStyle.standard} h-fit`}
                style={{
                    maxWidth: "100px",
                }}
                placeholder={"0.00"}
                value={weight}
                onChange={handleWeightChange}
            />
            kg
            {weightChanged &&
                <button
                    className={`${buttonStyle.btn} ${buttonStyle["btn-primary"]}`}
                    onClick={handleSaveButtonClick}
                >
                    {t("shipment.docs.save_button")}
                </button>
            }
        </div>
    )
}

export default DocsItem